import { RunElement } from '../../shared/run-element.js';
import { resolveSkinFromAncestors } from '../../shared/resolve-skin-name.js';
import * as defaultSkin from './skins/table-body.default.js';
import * as wireframeSkin from './skins/table-body.wireframe.js';

const _defaultSheet = new CSSStyleSheet();
_defaultSheet.replaceSync(defaultSkin.styles);

const _wireframeSheet = new CSSStyleSheet();
_wireframeSheet.replaceSync(wireframeSkin.styles);

class RunTableBody extends RunElement {
  connectedCallback() {
    super.connectedCallback();
  }

  updated(changedProperties) {
    const skin = this.#resolveSkin();
    if (skin === 'wireframe') {
      this.shadowRoot.adoptedStyleSheets = [_wireframeSheet];
      wireframeSkin.render(this);
    } else {
      this.shadowRoot.adoptedStyleSheets = [_defaultSheet];
      defaultSkin.render(this);
    }
  }

  #resolveSkin() {
    const s = this.getAttribute('skin');
    if (s) return s;
    return resolveSkinFromAncestors(this);
  }
}

if (!customElements.get('run-table-body')) {
  customElements.define('run-table-body', RunTableBody);
}

export { RunTableBody };
export default RunTableBody;
